
import { useEffect, useState } from 'react';
import { Button, Row, Spinner } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'
import Photo from './photo';

function Photos(props) {
const photos = props.photos;
const [bigPic, setBigPic] = useState('');



const myFunc = (e) =>{
    setBigPic(e);
    
  }

const spin = (e) => {
    let myVar;
    myVar = setTimeout(myFunc(e), 3000);
}
  

const clicked  = (event) => {
    setBigPic("spinner");
    
    spin(event.target.src)
    
  }  
  


  return (
    <div >
        <Row style={{marginBottom:"30px"}}>
            {bigPic && bigPic!= "spinner" ? <Image src={bigPic} style={{width:"500px", height:"400px"}} /> : ""}
            {bigPic && bigPic=="spinner" ? <Spinner/> : ""}
        </Row>
        <Row className="text-center center" style={{margin:"auto", }}>{photos.map(p => <Photo source={p} click={clicked}/>   )}</Row>
       
    </div>
  );
}

export default Photos;
